"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var material_1 = require("@angular/material");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var of_1 = require("rxjs/observable/of");
var operators_1 = require("rxjs/operators");
var service_1 = require("../../shared/api/service");
var model_1 = require("../../shared/impl/model");
var abstract_destruction_subject_1 = require("../../shared/utilities/abstract-destruction-subject");
var model_2 = require("./model");
require("./sis-entity-search.component.scss");
var EntitySearchComponent = /** @class */ (function (_super) {
    __extends(EntitySearchComponent, _super);
    function EntitySearchComponent(portfolioService, kbService) {
        var _this = _super.call(this) || this;
        _this.portfolioService = portfolioService;
        _this.kbService = kbService;
        /**
         * Transfer selected value.
         * @type {EventEmitter<any>}
         */
        _this.valueChange = new core_1.EventEmitter();
        /**
         * Load More Entity Serach Item
         * @type {EntitySearchItem}
         * @private
         */
        _this.loadMoreEntity = new model_2.EntitySearchItem(-1, 'loadMore');
        /**
         * Filtered data
         * @type {any[]}
         * @private
         */
        _this.filteredData = [];
        _this.DEFAULT_ROWS_COUNT = 2;
        /**
         * Rows to show after search.
         */
        _this.rowsToShow = _this.DEFAULT_ROWS_COUNT;
        _this.entitySearchCtrl = new forms_1.FormControl();
        _this.onFilterValueChange();
        return _this;
    }
    Object.defineProperty(EntitySearchComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (value) {
            this._value = value;
        },
        enumerable: true,
        configurable: true
    });
    EntitySearchComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.kbService
            .getMetaFields(this.filterableEntity)
            .pipe(operators_1.takeUntil(this.destroySubject$))
            .subscribe(function (metaFields) {
            _this.checkingFilterFieldsTypes(metaFields);
            _this.initFilteredCategoryInstanceFieldName(metaFields);
            _this.initSelectedEntity();
        }, function (err) { return console.log(err); });
    };
    EntitySearchComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes['filterableEntity'] &&
            changes['filterableEntity'].currentValue &&
            changes['filterableEntity'].previousValue) {
            this.filterableEntity = changes['filterableEntity'].currentValue;
            this.kbService
                .getMetaFields(this.filterableEntity)
                .pipe(operators_1.takeUntil(this.destroySubject$))
                .subscribe(function (metaFields) {
                _this.initFilteredCategoryInstanceFieldName(metaFields);
            }, function (err) { return console.log(err); });
        }
    };
    /**
     * Checking filtered fields types for given Filterable Entity's metaFields
     * @param {MetaField[]} metaFields
     */
    EntitySearchComponent.prototype.checkingFilterFieldsTypes = function (metaFields) {
        this.filterFields.forEach(function (filterField) {
            var isWrongFieldName = true;
            for (var _i = 0, metaFields_1 = metaFields; _i < metaFields_1.length; _i++) {
                var metaField = metaFields_1[_i];
                if (metaField.getSystemName() === filterField &&
                    metaField.getType() !== idm_kb_service_client_js_1.MetaFieldType.STRING &&
                    metaField.getType() !== idm_kb_service_client_js_1.MetaFieldType.MULTILINGUAL_STRING) {
                    throw new Error("Given " + filterField + " metaFiled's type is wrong. MetaFields' type must be either STRING or MULTILINGUAL_STRING");
                }
                else if (metaField.getSystemName() === filterField) {
                    isWrongFieldName = false;
                    break;
                }
            }
            if (isWrongFieldName) {
                throw new Error("Given " + filterField + " metaFiled's systemName is wrong.'");
            }
        });
    };
    EntitySearchComponent.prototype.onEntitySelected = function (event) {
        if (event.source.selected) {
            this.selectedEntity = event.source.value;
            this.entitySearchCtrl.setValue(event.source.value.displayName, {
                emitEvent: false,
            });
            this.rowsToShow = this.DEFAULT_ROWS_COUNT;
            this.valueChange.emit(this.selectedEntity.id);
        }
    };
    EntitySearchComponent.prototype.onLoadMoreSelected = function (event) {
        if (event.source.selected) {
            this.rowsToShow += this.DEFAULT_ROWS_COUNT;
            var displayName = this.entitySearchCtrl.value instanceof model_2.EntitySearchItem
                ? this.entitySearchCtrl.value.displayName
                : this.entitySearchCtrl.value;
            this.loadMoreEntity.displayName = displayName;
            this.entitySearchCtrl.setValue(displayName, { emitEvent: true });
        }
    };
    /**
     * Indicates when to show "Load more" option
     * @returns {boolean}
     */
    EntitySearchComponent.prototype.showLoadMoreOption = function () {
        return this.totalRows > this.rowsToShow;
    };
    EntitySearchComponent.prototype.isEmptyValue = function () {
        return (this.entitySearchCtrl.value === undefined ||
            this.entitySearchCtrl.value === null ||
            this.entitySearchCtrl.value === '');
    };
    /**
     * Indicates when to show "No More available items"
     * @returns {boolean}
     */
    EntitySearchComponent.prototype.showNoDataAvailable = function () {
        return (!this.isEmptyValue() &&
            this.selectedEntity === null &&
            this.filteredData.length === 0);
    };
    EntitySearchComponent.prototype.clearEntitySearchCtrl = function () {
        this.selectedEntity = null;
        this.rowsToShow = this.DEFAULT_ROWS_COUNT;
        this.totalRows = 0;
        this.filteredData = [];
        this.entitySearchCtrl.setValue('');
        this.valueChange.emit(null);
    };
    EntitySearchComponent.prototype.resetRowCount = function () {
        if (this.entitySearchCtrl.value === '') {
            this.rowsToShow = this.DEFAULT_ROWS_COUNT;
        }
    };
    EntitySearchComponent.prototype.trackByFunc = function (index, entity) {
        return entity.id;
    };
    EntitySearchComponent.prototype.onFilterValueChange = function () {
        var _this = this;
        this.filteredEntities = this.entitySearchCtrl.valueChanges.pipe(operators_1.debounceTime(500), operators_1.switchMap(function (value) {
            var searchValue = typeof value === 'string' ? value : value.displayName;
            return value === '' || value === null
                ? of_1.of(new model_1.ServiceResponseDefault())
                : _this.searchEntities(searchValue, new idm_de_core_frontend_1.PagingOptions(0, _this.rowsToShow));
        }), operators_1.map(function (filteredData) {
            _this.totalRows =
                filteredData.getMeta() !== undefined
                    ? filteredData.getMeta().getTotalRowCount()
                    : 0;
            if (!_this.autoComplete.autocomplete._isOpen &&
                !_this.selectedEntity) {
                _this.autoComplete.openPanel();
            }
            return (_this.filteredData =
                filteredData.getData() !== undefined
                    ? filteredData.getData()
                    : []);
        }));
    };
    EntitySearchComponent.prototype.initSelectedEntity = function () {
        var _this = this;
        if (this._value !== undefined && this._value !== null) {
            var filterBuilder = new idm_de_core_frontend_1.FilterBuilder();
            filterBuilder.is(this.nestedEntityInstanceName, this._value);
            this.portfolioService
                .loadEntitySearchItems(this.filterableEntity, this.filterFields, this.nestedEntityInstanceName, new idm_de_core_frontend_1.PagingOptions(0, 1), null, filterBuilder.buildJson(), this.categoryPermissionTypes)
                .pipe(operators_1.takeUntil(this.destroySubject$))
                .subscribe(function (data) {
                if (data.getMeta().getTotalRowCount() > 0) {
                    var searchedEntity_1 = data.getData()[0];
                    var filterFiledData = _this.filterFields.map(function (filterField) {
                        return searchedEntity_1.entity[filterField];
                    });
                    _this.selectedEntity = new model_2.EntitySearchItem(searchedEntity_1.entity[_this.nestedEntityInstanceName], filterFiledData.join(' | '), searchedEntity_1.entity);
                    _this.entitySearchCtrl.setValue(_this.selectedEntity.displayName);
                }
            }, function (err) { return console.log(err); });
        }
    };
    /**
     * Getting instance field name for given filterable Entity.
     * @param {MetaField[]} metaFields - Filterable Entity's metaFields
     */
    EntitySearchComponent.prototype.initFilteredCategoryInstanceFieldName = function (metaFields) {
        var integerInstanceMetaField = metaFields.find(function (metaField) {
            return metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.INTEGER_INSTANCE;
        });
        if (integerInstanceMetaField) {
            this.nestedEntityInstanceName = integerInstanceMetaField.getSystemName();
        }
        else {
            throw new Error("Given " + this.filterableEntity + " Category has no Instance Id");
        }
    };
    /**
     * Creates FilterCriteria according to the selected filters.
     * This will be passed to Entity Search Service.
     * @returns {FilterCriteria}
     */
    EntitySearchComponent.prototype.getMultiFieldFilterCriteria = function (searchableValue) {
        var mainFilterBuilder;
        if (this.filterFields !== undefined && this.filterFields !== null) {
            mainFilterBuilder = new idm_de_core_frontend_1.FilterBuilder();
            searchableValue !== undefined &&
                searchableValue !== null &&
                searchableValue.trim() !== '' &&
                mainFilterBuilder.multifield(new idm_de_core_frontend_1.MultifieldFilterCriteriaModel(searchableValue.trim(), this.filterFields));
        }
        return mainFilterBuilder.build();
    };
    EntitySearchComponent.prototype.searchEntities = function (searchableValue, pagingOptions) {
        return this.portfolioService.loadEntitySearchItems(this.filterableEntity, this.filterFields, this.nestedEntityInstanceName, pagingOptions, null, this.getMultiFieldFilterCriteria(searchableValue).toJson(), this.categoryPermissionTypes);
    };
    __decorate([
        core_1.Input('value'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], EntitySearchComponent.prototype, "value", null);
    __decorate([
        core_1.ViewChild('autoCompleteInput', { read: material_1.MatAutocompleteTrigger }),
        __metadata("design:type", material_1.MatAutocompleteTrigger)
    ], EntitySearchComponent.prototype, "autoComplete", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], EntitySearchComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], EntitySearchComponent.prototype, "titleKey", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], EntitySearchComponent.prototype, "filterableEntity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], EntitySearchComponent.prototype, "filterFields", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], EntitySearchComponent.prototype, "categoryPermissionTypes", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], EntitySearchComponent.prototype, "valueChange", void 0);
    EntitySearchComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-entity-search',
            template: require('./sis-entity-search.component.html'),
        }),
        __metadata("design:paramtypes", [service_1.PortfolioService,
            idm_kb_service_client_js_1.KbService])
    ], EntitySearchComponent);
    return EntitySearchComponent;
}(abstract_destruction_subject_1.AbstractDestructionSubject));
exports.EntitySearchComponent = EntitySearchComponent;
//# sourceMappingURL=sis-entity-search.component.js.map